import '../../../../assets/css/screens/customer/dashboard/helpsupport/HelpSupport.css';
import AppNavbar from '../../../../components/customer/dashboard/apphome/appnavbar/AppNavbar';
import React, { useState, useContext, useEffect } from 'react';
import AppContext from '../../../../context/AppContext';
import HelpSupportSkeleton from '../../../../components/skeltonloading/HelpSupportSkeleton';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import {
  ArrowLeft, Clock, CheckCircle, AlertCircle,
  MessageSquare, Headphones, ChevronRight, ShieldAlert
} from 'lucide-react';
const STATUS_CFG = {
  pending: { label: 'Pending', color: '#f59e0b', bg: 'rgba(245,158,11,0.12)', icon: <Clock size={13} /> },
  open: { label: 'Open', color: '#0491e1', bg: 'rgba(4,145,225,0.12)', icon: <AlertCircle size={13} /> },
  in_progress: { label: 'In Progress', color: '#8b5cf6', bg: 'rgba(139,92,246,0.12)', icon: <Clock size={13} /> },
  resolved: { label: 'Resolved', color: '#10b981', bg: 'rgba(16,185,129,0.12)', icon: <CheckCircle size={13} /> },
};

const HelpAndSupport = () => {
  const { baseUrl, authToken } = useContext(AppContext);
  const navigate = useNavigate();
  const [tickets, setTickets] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState('all');
  const [conversationId, setConversationId] = useState();

  const FILTERS = ['all', 'pending', 'in_progress', 'resolved'];

  const viewtikets = async () => {
    setLoading(true);

    try {
      const response = await axios.get(
        `${baseUrl}/customer/viewhelpsupport`,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${localStorage.getItem("authToken") || ""}`,
          },
        }
      );

      setTickets(response.data.helpsupports || []);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const filtered = filter === 'all'
    ? tickets
    : tickets.filter(t => t.status === filter);
  useEffect(() => {
    viewtikets();
  }, []);
  if (loading) {
    return (
      <>
        <AppNavbar />
        <div className="hs-page">
          <HelpSupportSkeleton />
        </div>
      </>
    );
  }
  return (
    <>
      <AppNavbar />
      <div className="hs-page">

        {/* ── Header ── */}
        <div className="hs-header">
          <button className="hs-back" onClick={() => navigate(-1)}>
            <ArrowLeft size={20} />
          </button>
          <div className="hs-header__info">
            <h2 className="hs-title">Help &amp; Support</h2>

          </div>
          <div className="hs-header__icon">
            <Headphones size={22} />
          </div>
        </div>

        <div className="hs-body">


          {/* ── Filter tabs ── */}
          <div className="hs-filters">
            {FILTERS.map(f => (
              <button
                key={f}
                className={'hs-filter-btn' + (filter === f ? ' hs-filter-btn--active' : '')}
                onClick={() => setFilter(f)}
              >
                {f === 'all' ? 'All' : STATUS_CFG[f]?.label || f}
                {f !== 'all' && (
                  <span className="hs-filter-count">
                    {tickets.filter(t => t.status === f).length}
                  </span>
                )}
              </button>
            ))}
          </div>

          {/* ── Ticket List ── */}
          {loading ? (
            <div className="hs-loading">
              <span className="hs-spinner" />
              Loading tickets...
            </div>
          ) : filtered.length === 0 ? (
            <div className="hs-empty">
              <div className="hs-empty__icon"><ShieldAlert size={36} /></div>
              <p className="hs-empty__text">No tickets found</p>
              <span className="hs-empty__sub">No support tickets in this category</span>
            </div>
          ) : (
            <div className="hs-tickets-list">
              {filtered.map((t, i) => {
                const st = STATUS_CFG[t.status] || STATUS_CFG.pending;
                const msgCount = t.whconversations?.length || 0;
                return (
                  <div
                    key={t.id}
                    className="hs-ticket-card"
                    style={{ animationDelay: i * 0.07 + 's' }}
                  >
                    {/* Top row */}
                    <div className="hs-ticket-card__top">
                      <div className="hs-ticket-card__left">
                        <div className="hs-ticket-card__cat-icon">
                          <Headphones size={16} />
                        </div>
                        <div>
                          <h5 className="hs-ticket-card__title">{t.category}</h5>
                          <div className="hs-ticket-card__tags">
                            <span className="hs-tag hs-tag--raised">By: {t.raisedby}</span>
                            <span className="hs-tag hs-tag--against">vs: {t.against}</span>
                          </div>
                        </div>
                      </div>
                      <span
                        className="hs-ticket-card__status"
                        style={{ color: st.color, background: st.bg }}
                      >
                        {st.icon} {st.label}
                      </span>
                    </div>

                    {/* Description */}
                    {t.description && (
                      <p className="hs-ticket-card__desc">{t.description}</p>
                    )}

                    {/* Footer */}
                    <div className="hs-ticket-card__footer">
                      <span className="hs-ticket-card__msgs">
                        <MessageSquare size={13} />
                        {msgCount} message{msgCount !== 1 ? 's' : ''}
                      </span>
                      <button
                        className="hs-ticket-card__chat-btn"
                        onClick={() =>
                          navigate(`/chat/${t.whconversations?.[0]?.id}`)
                        }
                      >
                        <MessageSquare size={14} /> Open Chat
                        <ChevronRight size={14} />
                      </button>
                    </div>
                  </div>
                );
              })}
            </div>
          )}

        </div>
      </div>
    </>
  );
};

export default HelpAndSupport;